import { Injectable } from '@angular/core';

@Injectable()
export class ImageCropperService {

  constructor () { }

  showModal (e) {
    $(e.modalEle).modal('show');
  }

}



// WEBPACK FOOTER //
// D:/taile-operate/BLACK-WIDOW/ng-src/app/services/image-cropper/image-cropper.service.ts